import { createContext } from "react";
export const AppMenuListContext = createContext({});
